export default __webpack_public_path__ + "static/media/ic_facebook.2c7819e9.svg";